module.exports = __webpack_public_path__ + "img/86.3.TP.68e6437e.png";